import { useSecaoTiposObra } from "./use-secao-tipos-obra";
import { SecaoTiposObraView } from "./view-secao-tipos-obra";
import type { SecaoTiposObraProps } from "./types-secao-tipos-obra";

export function SecaoTiposObra(props: SecaoTiposObraProps) {
  const vm = useSecaoTiposObra(props);

  return <SecaoTiposObraView {...props} {...vm} />;
}

export type * from "./types-secao-tipos-obra";
